import messages from '../../../locale/messages';
import { inputTextLimit } from '../../../helpers/FieldRestriction';

const validate = values => {
    const errors = {}

    if (!values.message) {
        errors.message = messages.messageRequired
    } else if (values.message == '') {
        errors.message = messages.messageRequired
    } else if (values.message && values.message.length > inputTextLimit) {
        errors.message = messages.inputTextLimitError;
    }

    return errors
}

export default validate;